import React, { useContext, useEffect, useState } from "react";
import { observer } from "mobx-react-lite";
import "./ArticleItem.css";
import BannerList from "../Banners/BannerList";
import PostList from "./PostList";
import { Context } from "../../../index";
import Banner from "../Banners/BannerItem";
import FeedbackForm from "../FeedbackForm/FeedbackForm";

const ArticleItem = ({ post, title, id, articleSeoName }) => {
 const { storeblog } = useContext(Context);
 const parser = new DOMParser();
 const parsedHtml = parser.parseFromString(post, "text/html");
 const imgTags = parsedHtml.getElementsByTagName("img");

 let photo = "";
 for (let i = 0; i < imgTags.length; i++) {
  if (!imgTags[i].closest(".article_banner_box")) {
   photo = imgTags[i].getAttribute("src");
   break;
  }
 }

 const [isMore, setIsMore] = useState(false);
 const [articleContent, setArticleContent] = useState([]);

 useEffect(() => {
  storeblog.setSelectedCategory("");
  console.log(storeblog.userWalker, '-uw')


  const parseArticle = (html) => {

   const bannerRegex = /{"banner":.*?}/g;

   const parts = html.split(bannerRegex);

   const banners = [...html.matchAll(bannerRegex)];

   const content = [];
   parts.forEach((part, index) => {
    content.push(part);

    if (banners[index]) {

     const bannerData = JSON.parse(banners[index][0]);


     content.push(
      <Banner
       key={bannerData.banner}
       bannerID={bannerData.banner}
       title={bannerData.title}
       link={bannerData.link}
       photo={bannerData.photo}
       articleSeoName={articleSeoName}
       bannerSeoName={bannerData.bannerSeoName}
       type={"article"}
       articleId={id}
      />
     );
    }
   });

   return content;
  };

  setArticleContent(parseArticle(post));
 }, [id, post, storeblog]);

 return (
  <div className="px-9">
   <div className="article_box">
    {post !== "" ? (
     isMore ? (

      <div className="article_body">
       {articleContent.map((item, index) => {
        if (typeof item === "string") {
         return (
          <div key={index} dangerouslySetInnerHTML={{ __html: item }}></div>
         );
        } else {
         return <React.Fragment key={index}>{item}</React.Fragment>;
        }
       })}
      </div>
     ) : (
      <div className="article_body">
       <h2>
        <img src={photo} alt="photo" />
       </h2>
       <h2>{title}</h2>
       <button className="article_more_btn" onClick={() => setIsMore(!isMore)}>
        Ver más
       </button>
      </div>
     )
    ) : (
     <div className="article_body">
      <div className="loader_box">
       <div className="loader"></div>
      </div>
     </div>
    )}
    <div className="banners_box">
     {storeblog.userWalker === storeblog.trueWalker ? (
      <BannerList id={id} articleSeoName={articleSeoName} />
     ) : (
      <FeedbackForm />
     )}
    </div>
   </div>
   <div>
    <hr className="my-6 w-[90%] mx-auto" />
    <div className="d-flex flex-wrap justify-content-center mx-2">
     <PostList />
    </div>
   </div>
  </div>
 );
};

export default observer(ArticleItem);
